/**
 * In-memory UserStore key names for session-scoped dashboard state.
 *
 * @module userGeneralInfoContextKeys
 */

/**
 * Keys used with {@link UserStore} for user/session data and per-order caches.
 */
export enum UserGeneralInfoContextKeys {
  VIEW_LEGACY = "viewLegacy",
  USER_ID = "userId",
  HEALTHCARE_FACILITY_ID = "healthcareFacilityId",
  INTERNAL_ORGANIZATION_FACILITY_ID = "internalOrganizationFacilityId",
  ORG_NAME = "orgName",
  PARENT_TABLE = "parentTable",
  BO_COMMENTS = "boComments",
  JCODE_DOCS = "jCodeDocs",
  GLOBAL_BO_VALUE = "globalBoValue",
  AUTH_STATUS_CHANGE_COMMENTS = "authStatusChangeComments",
  /** Staged denial/query reasons pending flush on CPT save. */
  DENIAL_QUERY_REASONS = "denialQueryReasons",
  CPT_CODES = "cptCodes",
  J_CODES = "jCodes",
  EXISTING_JCODE_DOCS = "existingJCodeDocs",
  MEDICINE_NAMES = "medicineNames",
  INDEX_TAB = "indexTab",
  PAYER_NAME = "payerName",
  ENABLE_REVIEW_MODE = "enableReviewMode",
  // PROVIDER_NAME = "providerName",
}
